import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Experience from './Experience';
import Education from './Education';
import Skills from './Skills';
import './Resume.css';

function Resume() {
  return (
    <Container id='resume'>
      <Row>
        <Col>
          <div>
            <Education></Education>
          </div>
          <div>
            <Skills></Skills>
          </div>
        </Col>
        <Col><Experience></Experience></Col>
      </Row>
    </Container>
  );
}

export default Resume;
